import * as React from "react";

import {ModalLauncher} from "@khanacademy/wonder-blocks-modal";

import {GuideClosetModal} from "./guide-closet-modal.tsx";

interface Props {
    /** Specifies whether the modal is opened */
    opened: boolean;
    /** A callback that is triggered when the modal is dismissed */
    onClose: () => unknown;
}

/**
 * Responsible for controlling the rendering Khanmigo's closet modal
 */
export const GuideClosetLauncher = ({
    opened,
    onClose,
}: Props): React.ReactElement => (
    <ModalLauncher
        backdropDismissEnabled
        modal={<GuideClosetModal onClose={onClose} />}
        opened={opened}
        onClose={onClose}
    />
);
